import { IonFooter } from '@ionic/react'
import React, { ReactNode, FC, useCallback, useState } from 'react'
import { format } from '@dt/fe-utils'
import { Stepper } from 'components'
import { observer } from 'mobx-react'
import './index.scss'

interface IProps {
  disableTogo?: boolean; // 不能打包
  disableReserve?: boolean; // 不能预约
  soldOut?: boolean;
  cnt: number;
  maxCnt?: number;
  setCnt: (value: number) => void;
  salesCnt?: number;
  modalFrom: 'menu' | 'cart';
  addToCart: () => void;
  totalPrice?: number;
  totalActualPrice?: number;
  disabled: boolean;
  restingStore?: boolean;
  pauseAllEatType?: boolean;
  pauseMobileOrderEndTime?: string;
  hasStepper?: boolean;
  hasResetBtn?: boolean;
  resetCart?: () => void;
  CustomCom?: ReactNode | boolean;
}

const Footer: FC<IProps> = ({ soldOut = false, cnt, maxCnt, setCnt, salesCnt = 1, modalFrom, addToCart, totalPrice, totalActualPrice, disabled, restingStore = false, pauseAllEatType = false, pauseMobileOrderEndTime = '', hasStepper = true, hasResetBtn = false, resetCart, disableTogo, disableReserve, CustomCom }) => {
  const handleChangeCnt = useCallback((isAdd: boolean) => {
    let _cnt = cnt + (isAdd ? 1 : -1)
    // 减餐品小于起售份数全部清空数量
    if (!isAdd && _cnt < salesCnt) {
      _cnt = 0
    }
    setCnt(_cnt)
  }, [cnt, salesCnt])
  const handleEditCnt = useCallback((value) => {
    // 减餐品小于起售份数全部清空数量
    if (value < salesCnt) {
      return
    }
    setCnt(value)
  }, [cnt, salesCnt])
  return (
    <IonFooter className='footer-btn-wrap'>
      {!!CustomCom && CustomCom}
      <div>
        {
          restingStore ? (
            <div className='footer-btn'>
              <div className='primary-btn disabled'>{i18n.t('store.restingStore')}</div>
            </div>
          ) : pauseAllEatType ? (
            <div className='footer-btn'>
              <div className='primary-btn disabled'><span className='pause-order-tip1'>{i18n.t('store.pauseOrdering1')}</span><span className='pause-order-tip2'>{i18n.t('store.openOrdering1', { time: pauseMobileOrderEndTime })}</span></div>
            </div>
          ) : soldOut ? (
            <div className='footer-btn'>
              <div className='primary-btn disabled'>{i18n.t('common.soldout')}</div>
            </div>
          ) : (
            <div className='footer-btn'>
              {hasResetBtn && <div className='reset-btn' data-cypid='productDetailReset' onClick={resetCart}>{i18n.t('modifier.reset')}</div>}
              {hasStepper && <Stepper cnt={cnt} onEdit={handleEditCnt} onChange={handleChangeCnt} min={modalFrom === 'menu' ? salesCnt : 0} max={maxCnt} theme='primary' size='large' disabled={disableTogo} />}
              {
                disableReserve ? (
                  <div className='primary-btn disabled'>{i18n.t('newCart.noInReserveTime')}</div>
                ) : disableTogo ? (
                  <div className='primary-btn disabled'>{i18n.t('newCart.canNotTogo')}</div>
                ) : (
                  <div
                    className={`primary-btn${disabled ? ' disabled' : ''}`}
                    data-cypid='productDetailConfirm'
                    onClick={() => addToCart()}
                  >
                    <div className='footer-sub1'>{modalFrom === 'menu' ? i18n.t('productdetail.addCart') : i18n.t('productdetail.save')}</div>
                    {cnt ? (
                      <>
                        <div className='footer-price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(totalActualPrice * cnt) }}></div>
                        {totalPrice !== totalActualPrice ? <div className='footer-noprice' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(totalPrice * cnt) }}></div> : null}
                      </>
                    ) : null}
                  </div>
                )
              }
            </div>
          )
        }
      </div>
    </IonFooter>
  )
}

export default Footer
